import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { DataTable, Excel } from 'CommonComponent';
import { isEmpty } from 'lodash';

const WeeklyBillingList = ({extraFiltersState, setExtraFiltersState, taskFilterValue = ""}) => {
    const [columns, setColumns] = useState([]);
    

    const session = useSelector((s) => s.session);
    const { data, headers, loading } = useSelector(state => state.timesheetReportsState.weeklySummary);

    const object_viewed_id = session?.current_page_permissions?.object_id || "";
    
    useEffect(() => {
        if (headers) {
            const generatedColumns = generateColumns(headers);
            setColumns(generatedColumns);
        }
    }, [headers]);

    // Helper function to format hours/amounts
    const formatValue = (value) => {
        if (typeof value === 'number') {
            return (
                <span>
                    {value.toFixed(2)}
                </span>
            )
        }
        return value;
    };

    const generateColumns = (headers) => {
        const staticColumns = [
            {
                id: "week_ending",
                header: "Week Ending",
                accessor: (row) => row.week_ending,
                sortable: true,
                searchable: true,
            },
            {
                id: "regular_hours",
                header: "Regular",
                accessor: (row) => row.regular_hours,
                sortable: false,
                searchable: false,
                cell: (value) => formatValue(value)
            },
            {
                id: "OT",
                header: "OT",
                accessor: (row) => row.OT,
                sortable: false,
                searchable: false,
                cell: (value) => formatValue(value)
            },
            {
                id: "Total",
                header: "Total",
                accessor: (row) => row.Total,
                sortable: false,
                searchable: false,
                cell: (value) => formatValue(value)
            },
        ];

        const dynamicColumns = Object.entries(headers).map(([key, header]) => {
            if (!['week_ending', 'regular_hours', 'OT', 'Total'].includes(key)){
                return {
                    id: key,
                    header: header,
                    accessor: (row) => row[key],
                    cell: (value) => formatValue(value),
                    sortable: false,
                    searchable: false,
                }
            } 
            return null;
            
        }).filter(Boolean);

        return [...staticColumns, ...dynamicColumns];
    };


    const filteredData = (Array.isArray(data) ? data : []).filter((row) => {
        if (!taskFilterValue) return true;
        const taskValue = String(row?.category_task || row?.task || "");
        return taskValue === taskFilterValue;
    });

    return (
        <div className="monthlybilling-table-container"> 
            
            <DataTable
                columns={columns}
                data={filteredData}
                serverSide={false}
                showSearch={false}
                loading={loading}
            />
        </div>
    )
}

export default WeeklyBillingList;